import { createI18n } from 'vue-i18n'
import store from './store/'

const i18n = createI18n({
  legacy: false,
  locale: store.getters.currentLocale || 'en',
  fallbackLocale: 'en',
  globalInjection: true,
  messages: {}
})

export async function loadLocaleMessages(locale) {
  if (!i18n.global.availableLocales.includes(locale)) {
    const messages = await import(`./locales/${locale}.js`)
    i18n.global.setLocaleMessage(locale, messages.default)
  }
  i18n.global.locale.value = locale
  store.dispatch('setLocale', locale)
}

export default i18n
